import { type ReactNode } from 'react'
import { cn } from '#app/utils/misc.tsx'

interface Props {
	title?: string
	description?: ReactNode
	children?: ReactNode
	className?: string
	actions?: ReactNode
}

export function Page({
	title,
	description,
	children,
	className,
	actions,
}: Props) {
	return (
		<div className={cn(className)}>
			{(title || description || actions) && (
				<div className="mb-6 space-y-3">
					<div className="flex items-start justify-between gap-3">
						<div className="min-w-0 flex-1 space-y-1">
							{title && (
								<h2 className="text-foreground text-lg font-semibold">
									{title}
								</h2>
							)}
							{typeof description === 'string' ||
							typeof description === 'number' ? (
								<p className="text-muted-foreground text-sm">{description}</p>
							) : description ? (
								<div className="text-muted-foreground text-sm">
									{description}
								</div>
							) : null}
						</div>
						{actions && (
							<div className="flex flex-shrink-0 items-center gap-2">
								{actions}
							</div>
						)}
					</div>
				</div>
			)}
			{children}
		</div>
	)
}
